'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var styledComponents = require('./styled-components.js');

var VerticalSplitLayout = function (props) {
    var leftComponent = props.leftComponent, rightComponent = props.rightComponent, leftGridSize = props.leftGridSize, rightGridSize = props.rightGridSize;
    return (React__default.createElement(styledComponents.StyledGridContainer, { container: true },
        React__default.createElement(styledComponents.GridRightBorder, { item: true, xs: 12, md: leftGridSize }, leftComponent),
        React__default.createElement("div", null),
        React__default.createElement(core.Grid, { item: true, xs: 12, md: rightGridSize }, rightComponent)));
};
VerticalSplitLayout.defaultProps = {
    leftGridSize: 6,
    rightGridSize: 6,
};

module.exports = VerticalSplitLayout;
